const SW_UPDATING_KEY = 'talentfunn_sw_updating';
const SW_UPDATING_STARTED_AT_KEY = 'talentfunn_sw_updating_started_at';
const SW_UPDATED_KEY = 'talentfunn_sw_updated';
const SW_UPDATE_IN_PROGRESS_KEY = 'talentfunn_sw_update_in_progress';

const SW_UPDATE_GUARD_TTL_MS = 3 * 60 * 1000;

function safeGetStorageItem(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetStorageItem(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value);
  } catch {
    // ignore storage write failures
  }
}

function safeRemoveStorageItem(storage: Storage, key: string): void {
  try {
    storage.removeItem(key);
  } catch {
    // ignore storage cleanup failures
  }
}

function getStartedAtMs(): number | null {
  if (typeof sessionStorage === 'undefined' || typeof localStorage === 'undefined') return null;
  const raw =
    safeGetStorageItem(sessionStorage, SW_UPDATING_STARTED_AT_KEY) ??
    safeGetStorageItem(localStorage, SW_UPDATING_STARTED_AT_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function markSwUpdating(): void {
  if (typeof sessionStorage === 'undefined' || typeof localStorage === 'undefined') return;
  const now = Date.now().toString();
  safeSetStorageItem(sessionStorage, SW_UPDATING_KEY, 'true');
  safeSetStorageItem(localStorage, SW_UPDATING_KEY, 'true');
  safeSetStorageItem(sessionStorage, SW_UPDATING_STARTED_AT_KEY, now);
  safeSetStorageItem(localStorage, SW_UPDATING_STARTED_AT_KEY, now);
}

export function markSwUpdated(): void {
  if (typeof sessionStorage === 'undefined') return;
  safeSetStorageItem(sessionStorage, SW_UPDATED_KEY, 'true');
}

export function isSwUpdateGuardActive(): boolean {
  if (typeof sessionStorage === 'undefined' || typeof localStorage === 'undefined') return false;
  const active =
    safeGetStorageItem(sessionStorage, SW_UPDATING_KEY) === 'true' ||
    safeGetStorageItem(localStorage, SW_UPDATING_KEY) === 'true';
  if (!active) return false;

  const startedAt = getStartedAtMs();
  if (startedAt === null) return true;
  const isExpired = Date.now() - startedAt > SW_UPDATE_GUARD_TTL_MS;
  if (isExpired) {
    clearSwUpdateGuard();
    return false;
  }
  return true;
}

export function clearSwUpdateGuard(): void {
  if (typeof sessionStorage === 'undefined' || typeof localStorage === 'undefined') return;
  safeRemoveStorageItem(sessionStorage, SW_UPDATING_KEY);
  safeRemoveStorageItem(localStorage, SW_UPDATING_KEY);
  safeRemoveStorageItem(sessionStorage, SW_UPDATING_STARTED_AT_KEY);
  safeRemoveStorageItem(localStorage, SW_UPDATING_STARTED_AT_KEY);
  safeRemoveStorageItem(sessionStorage, SW_UPDATE_IN_PROGRESS_KEY);
}

export function consumeSwUpdatedFlag(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  const wasUpdated = safeGetStorageItem(sessionStorage, SW_UPDATED_KEY) === 'true';
  safeRemoveStorageItem(sessionStorage, SW_UPDATED_KEY);
  return wasUpdated;
}

export function hasSwUpdatedFlag(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return safeGetStorageItem(sessionStorage, SW_UPDATED_KEY) === 'true';
}

